export const blockIconsHomeBatteryHoriz000New = (
	<span className='material-symbols-outlined'>battery_horiz_000</span>
);
